import { render, staticRenderFns } from "./switchComponent.vue?vue&type=template&id=0470e46d&scoped=true"
import script from "./switchComponent.vue?vue&type=script&lang=js"
export * from "./switchComponent.vue?vue&type=script&lang=js"
import style0 from "./switchComponent.vue?vue&type=style&index=0&id=0470e46d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0470e46d",
  null
  
)

export default component.exports